module.exports = __webpack_public_path__ + "img/intre.914ea4ac.jpg";